export const EVENT_FALLBACK_BACKGROUND = '#cccccc'

export const DEFAULT_CONTRAST_THRESHOLD = 0.4

export type ContrastPalette = {
  isDark: boolean
  primaryText: string
  secondaryText: string
}

export type EventCardColors = {
  backgroundColor: string
  palette: ContrastPalette
}

export const getLuminance = (hex: string): number => {
  let cleanHex = hex.replace('#', '')
  if (cleanHex.length === 3) {
    cleanHex = cleanHex[0] + cleanHex[0] + cleanHex[1] + cleanHex[1] + cleanHex[2] + cleanHex[2]
  }
  const r = parseInt(cleanHex.substring(0, 2), 16) / 255
  const g = parseInt(cleanHex.substring(2, 4), 16) / 255
  const b = parseInt(cleanHex.substring(4, 6), 16) / 255
  const toLinear = (c: number) => (c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4))
  return 0.2126 * toLinear(r) + 0.7152 * toLinear(g) + 0.0722 * toLinear(b)
}

export const getContrastPalette = (hex: string, threshold: number = DEFAULT_CONTRAST_THRESHOLD): ContrastPalette => {
  const isDark = getLuminance(hex) <= threshold
  return {
    isDark,
    primaryText: isDark ? '#ffffff' : '#000000',
    secondaryText: isDark ? 'rgba(255, 255, 255, 0.8)' : '#666666',
  }
}

export const getEventCardColors = (crewForemanColor: string | null): EventCardColors => {
  const backgroundColor = crewForemanColor || EVENT_FALLBACK_BACKGROUND
  return {
    backgroundColor,
    palette: getContrastPalette(backgroundColor),
  }
}
